import permissions from './permission-list'

export default [
  {
    path: '/brands',
    name: 'brands',
    component: () => import('@/views/brands/index.vue'),
    meta: {
      pageTitle: 'Daftar Brand',
      resource: permissions.brand,
      action: 'read',
      navActiveLink: 'brands',
      breadcrumb: [
        {
          text: 'Daftar Brand',
          active: true,
        },
      ],
    },
  },
  {
    path: '/brands/create',
    name: 'brands-create',
    component: () => import('@/views/brands/create.vue'),
    meta: {
      pageTitle: 'Buat Brand',
      resource: permissions.brandV2,
      action: 'manage',
      navActiveLink: 'brands-v2',
      breadcrumb: [
        {
          text: 'Brand',
          active: false,
          to: { path: '/v2/brands' },
        },
        {
          text: 'Buat',
          active: true,
        },
      ],
    },
  },
  {
    path: '/brands/:id/edit',
    name: 'brands-edit',
    component: () => import('@/views/brands/edit.vue'),
    meta: {
      pageTitle: 'Edit Brand',
      resource: permissions.brandV2,
      action: 'read',
      navActiveLink: 'brands-v2',
      breadcrumb: [
        {
          text: 'Brand',
          active: false,
          to: { path: '/v2/brands' },
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
